import React from "react";
import './shapesStyle.css'
import ShapeToNodeType from "./shapeToNodeType";
import { SHAPES, TEXT_NODE_TYPES } from './shapeCatalog';

// One node component per type, created once so the canvas sees stable node types.
const makeNodeType = ({ type, width, height }) => {
  const NodeType = ({ id, data, selected }) => (
    <ShapeToNodeType
      nodeId={id}
      data={data}
      isSelected={selected}
      initialWidth={width}
      initialHeight={height}
      type={type}
    />
  );
  NodeType.displayName = `${type}Node`;
  return NodeType;
};

export const nodeTypes = Object.fromEntries(
  [...SHAPES, ...TEXT_NODE_TYPES].map((shape) => [shape.type, makeNodeType(shape)])
);
